import Box from "@mui/material/Box";
import { useState } from "react";
import { Alert, Button } from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

// components
import { VerticalTabs } from "./vertical-tabs";
import { LoaderMUI } from "../../../assets/global/loader/loader-mui";
import { AlertMessage } from "../../../assets/global/alert/alert-message";
import { AreaProgressBar } from "../../planner/sidebar/area-progress-bar";

// services
import { luckyorangeTrackEven } from "../../../services/lucky-orange/luckyorange-events";
import { PROPERTY_SOURCE } from "../../../constants/site-settings.constants";
import { useSiteSettingsContext } from "../../../services/context/site-settings-context";
import { useUserContext } from "../../../services/context/user-context";
import { axiosInstance } from "../../../services/api/api";

// svg
import { ReactComponent as IconArrowLeft } from "../../../assets/svg/arrow-left.svg";
import { ViewOnlyMsg } from "../../layout/view-only-msg";

export const SidebarSiteSettings = ({
  propertyData,
  currentStep,
  setCurrentStep,
  steps,
  updatePropertyData,
  buildingArea,
  maxInnerBuildHeight,
  isValidPolygon,
  deleteDrawing,
}) => {
  const navigate = useNavigate();
  const { projectId, companyId } = useParams();
  const [searchParams] = useSearchParams();
  const userToken = searchParams.get("token");
  const { viewOnly } = useUserContext();
  const { uploading, setUploading, setHideGeoJSON } = useSiteSettingsContext();

  const [regulationsError, setRegulationsError] = useState(false);

  const [showApiAlert, setShowApiAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (event, newValue) => {
    setCurrentStep(newValue);
  };

  const goToNextStep = () => {
    luckyorangeTrackEven("Site Settings: go to next step");
    if (currentStep === 1) {
      setUploading(false);
      setHideGeoJSON(false);
      if (
        propertyData.propertySource === PROPERTY_SOURCE.FILE &&
        propertyData.uploadedPropertyGeoJSON
      ) {
        updatePropertyData(
          "propertyGeoJSON",
          propertyData.uploadedPropertyGeoJSON,
        );
      }
    }
    setCurrentStep((prev) => prev + 1);
  };

  const goToPreviousStep = () => {
    luckyorangeTrackEven("Site Settings: go to previous step");
    setCurrentStep((prev) => prev - 1);
  };

  const goToMainPage = () => {
    luckyorangeTrackEven("Site Settings: back to results");
    navigate(
      `/company/${companyId}/project/${projectId}/map/results?token=${userToken}`,
    );
  };

  const handleSave = async (propertyData) => {
    setLoading(true);
    setError(null);
    setShowApiAlert(false);

    try {
      const response = await saveProject(propertyData);
      setShowApiAlert(true);
      /* setTimeout(() => { */
      goToMainPage();
      /*  }, 500); */
    } catch (error) {
      // Handle error
      setError(error.response ? error.response.data.message : error.message);
    } finally {
      setLoading(false);
    }
  };

  const saveProject = (propertyData) => {
    return axiosInstance.post("runners/saveproperty", propertyData);
  };

  const handleSaveBtn = () => {
    luckyorangeTrackEven("Site Settings: save property");
    const side = propertyData.selectedLine.properties.id.split("_")[1];

    const propertyDataFull = {
      /* ...propertyDataJSON, */
      projectId: projectId,
      property: {
        geodata: propertyData.propertyGeoJSON.features[0],
        entrySide: Number(side),
        access1: propertyData.selectedLine,
        area: propertyData.area,
        perimeter: propertyData.perimeter,
        minBorderDistance: Number(propertyData.minBorderDistance),
        maxConstrHeight: Number(propertyData.maxConstrHeight),
        buildingDensity: Number(propertyData.buildingDensity),
        location: propertyData.location,
        locationGeodata: propertyData.locationGeodata,
        coordinates: propertyData.coordinatesCenter,
        propertyArea: propertyData.propertyArea,
        siteSource: propertyData.propertySource,
        fileId: propertyData.fileId,
        units: Number(propertyData.units),
        center: {
          lat: propertyData.center ? propertyData.center.lat : null,
          long: propertyData.center ? propertyData.center.long : null,
        },
      },
    };

/*     const propertyDATA = {
      projectId: projectId,
      property: {
        area: 349731.69,
        buildingDensity: 0,
        access1: {
          type: "Feature",
          state: {},
          geometry: {
            type: "LineString",
            coordinates: [
              [21.635119020938873, 47.47018804150338],
              [21.62867099046707, 47.47004843239904],
            ],
          },
          properties: {
            id: "bcd7371fc8cfbf5a06b23913bac7b446_4",
            lineName: "ea",
          },
          layer: {
            id: "edges-layer",
            type: "line",
            source: "edges",
            layout: { "line-join": "round", "line-cap": "round" },
            paint: {
              "line-color": {
                r: 0.9372549019607843,
                g: 0.6352941176470588,
                b: 0.11764705882352941,
                a: 1,
              },
              "line-width": 8,
              "line-opacity": 1,
            },
          },
          source: "edges",
        },
        locationGeodata: {
          id: "address.3108497363588332",
          type: "Feature",
          place_type: ["address"],
          relevance: 0.892593,
          properties: {
            accuracy: "point",
            mapbox_id:
              "dXJuOm1ieGFkcjplOGQzZDJmOS00OTcwLTQ5OTUtYjgxZC0wMzllNDE5ZGUwZjg",
          },
          "text_de-DE": "Hermann Kronseder Utca",
          "place_name_de-DE":
            "Debrecen, Hermann Kronseder Utca 1, 4002, Komitat Hajdú-Bihar, Ungarn",
          text: "Hermann Kronseder Utca",
          place_name:
            "Debrecen, Hermann Kronseder Utca 1, 4002, Komitat Hajdú-Bihar, Ungarn",
          matching_place_name:
            "Debrecen, Hermann Kronseder Utca 1, 4002, Hajdú-Bihar, Hungary",
          center: [21.632448, 47.469959],
          geometry: { type: "Point", coordinates: [21.632448, 47.469959] },
          address: "1",
          context: [
            {
              id: "postcode.8621670",
              mapbox_id: "dXJuOm1ieHBsYzpnNDVt",
              "text_de-DE": "4002",
              text: "4002",
            },
            {
              id: "place.4556902",
              mapbox_id: "dXJuOm1ieHBsYzpSWWht",
              wikidata: "Q79880",
              "text_de-DE": "Debrecen",
              "language_de-DE": "de",
              text: "Debrecen",
              language: "de",
            },
            {
              id: "region.25702",
              mapbox_id: "dXJuOm1ieHBsYzpaR1k",
              wikidata: "Q185368",
              short_code: "HU-HB",
              "text_de-DE": "Komitat Hajdú-Bihar",
              "language_de-DE": "de",
              text: "Komitat Hajdú-Bihar",
              language: "de",
            },
            {
              id: "country.8806",
              mapbox_id: "dXJuOm1ieHBsYzpJbVk",
              wikidata: "Q28",
              short_code: "hu",
              "text_de-DE": "Ungarn",
              "language_de-DE": "de",
              text: "Ungarn",
              language: "de",
            },
          ],
          _source: "mapbox",
        },
        perimeter: 2398.65,
        coordinates: {
          lat: 47.46720317525447,
          long: 21.631792674867683,
        },
        location: "Debrecen, Mikepércsi Út, 4030, Hajdú-Bihar, Hungary",
        maxConstrHeight: 15,
        geodata: {
          id: "bcd7371fc8cfbf5a06b23913bac7b446",
          type: "Feature",
          properties: {},
          geometry: {
            coordinates: [
              [
                [21.62867216348087, 47.470049022644304],
                [21.62823058168084, 47.46961122303878],
                [21.627818438667305, 47.46429763712183],
                [21.63576691106806, 47.464218028754885],
                [21.635119257761232, 47.47018832175405],
                [21.62867216348087, 47.470049022644304],
              ],
            ],
            type: "Polygon",
          },
        },
        minBorderDistance: 5,
        center: {
          lat: null,
          long: null,
        },
        units: 6,
        siteSource: "HAND_DRAWN",
        entrySide: 0,
        fileId: null
      },
    }; */

/*     console.log(propertyDataFull, propertyDATA);
 */
    handleSave(propertyDataFull);
  };

  return (
    <>
      {/* Loader */}
      {loading && <LoaderMUI withBackdrop={true} />}

      {/* Error Alert */}
      {error && <AlertMessage message={error} type="error" />}

      {/* Success Alert */}
      {showApiAlert && (
        <AlertMessage message={"Property saved"} type="success" />
      )}

      <Box
        sx={{
          width: "320px",
          height: "calc(100% - 80px - 74px)", // 80px -top, 74px - bottom
          background: "#FBFBFD",
          borderRadius: "16px",
          position: "absolute",
          top: "80px",
          left: "16px",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          /* alignItems: 'center', */
          justifyContent: "space-between",
          overflow: "auto",
          boxShadow: 3,
        }}
      >
        {viewOnly && <ViewOnlyMsg />}
        <Box
          sx={{
            flexGrow: 0,
            display: "flex",
            height: "100%",
            width: "100%",
            p: "16px 16px 16px 0",
          }}
        >
          <VerticalTabs
            tabValue={currentStep}
            handleChange={handleChange}
            propertyData={propertyData}
            updatePropertyData={updatePropertyData}
            steps={steps}
            regulationsError={regulationsError}
            setRegulationsError={setRegulationsError}
            maxInnerBuildHeight={maxInnerBuildHeight}
            isValidPolygon={isValidPolygon}
            setUploading={setUploading}
            uploading={uploading}
            deleteDrawing={deleteDrawing}
          />
        </Box>

        <Box
          sx={{
            flexGrow: 0,
            display: "flex",
            /* height: "calc(100% - 68.5px)", // btn area height */
            width: "100%",
            flexDirection: "column",
          }}
        >
          {buildingArea > 0 && propertyData.area && (
            <AreaProgressBar
              buildingAreaSum={buildingArea}
              propertyArea={propertyData.area}
            />
          )}
          {maxInnerBuildHeight > 0 &&
            propertyData.maxConstrHeight &&
            maxInnerBuildHeight > Number(propertyData.maxConstrHeight) && (
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                  margin: "0 auto",
                  padding: "0 16px 16px 16px",
                }}
              >
                <Alert
                  severity={"error"}
                  sx={{ width: "100%", fontSize: "12px" }}
                >
                  The minimum inner clearance height in one or more buildings
                  exceeds the maximum construction height. Please adjust the
                  values.
                </Alert>
              </Box>
            )}
          {!isValidPolygon && (
            <Box
              sx={{
                width: "100%",
                position: "relative",
                margin: "0 auto",
                padding: "0 16px 16px 16px",
              }}
            >
              <Alert
                severity={"error"}
                sx={{ width: "100%", fontSize: "12px" }}
              >
                Polygon is self-intersecting! Please fix it before proceeding.
              </Alert>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              gap: "16px",
              alignItems: "center",
              justifyContent: "flex-end",
              padding: "16px",
            }}
          >
            <Button
              sx={{
                background: "transparent",
                color: "#343745",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                ":hover": {
                  boxShadow: 4,
                  /*  background: '#fff' */
                },
              }}
              onClick={goToMainPage}
            >
              <IconArrowLeft
                stroke="#5d5f6a"
                /*  strokeWidth={"2px"} */
                width={"18px"}
                height={"18px"}
              />
              Results
            </Button>
            <Button
              sx={{
                background: "#fff",
                color: "#343745",
                display: currentStep === 0 ? "none" : null,
                textTransform: "none",
                boxShadow: 2,
                ":hover": {
                  boxShadow: 4,
                },
              }}
              onClick={goToPreviousStep}
            >
              Back
            </Button>
            <Button
              sx={{
                background: "#343745",
                color: "#fff",
                display: currentStep === 3 ? "none" : null,
                textTransform: "none",
                boxShadow: 2,
                ":disabled": {
                  color: "#C7C7D6",
                  background: "#EEEEF6",
                },
                ":hover": {
                  boxShadow: 4,
                },
              }}
              disabled={
                (currentStep === 0 && !steps.location) ||
                (currentStep === 1 && !steps.boundaries) ||
                (currentStep === 2 && !steps.access) ||
                !isValidPolygon
              }
              onClick={goToNextStep}
            >
              Next
            </Button>
            <Button
              sx={{
                background: "#EFA21E",
                color: "#fff",
                display: currentStep === 3 ? null : "none",
                textTransform: "none",
                boxShadow: 2,
                ":disabled": {
                  color: "#C7C7D6",
                  background: "#EEEEF6",
                },
                ":hover": {
                  boxShadow: 4,
                },
              }}
              disabled={
                viewOnly ||
                !steps.location ||
                !steps.boundaries ||
                !steps.access ||
                !steps.regulations ||
                regulationsError ||
                !isValidPolygon
              }
              onClick={handleSaveBtn}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
